module.exports = __webpack_public_path__ + "static/img/xeo-logo-white.9a92cc60.png";